var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6118 11.8799H8.19531V19.7401H10.6118V11.8799Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1483 11.7091C17.0592 11.6978 16.9645 11.6921 16.8699 11.6864C15.5169 11.6296 14.7541 12.4474 14.4868 12.7996C14.4144 12.8961 14.381 12.9529 14.381 12.9529V11.9022H12.0703V19.7624H14.381H14.4868C14.4868 18.9616 14.4868 18.1665 14.4868 17.3657C14.4868 16.9341 14.4868 16.5025 14.4868 16.0708C14.4868 15.537 14.4478 14.9691 14.7095 14.4806C14.9322 14.0717 15.3331 13.8673 15.7841 13.8673C17.1204 13.8673 17.1483 15.0997 17.1483 15.2133C17.1483 15.2189 17.1483 15.2246 17.1483 15.2246V19.7965H19.5648V14.6681C19.5648 12.9131 18.6906 11.8795 17.1483 11.7091Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.40312 10.8624C10.178 10.8624 10.8063 10.2216 10.8063 9.43119C10.8063 8.64077 10.178 8 9.40312 8C8.6282 8 8 8.64077 8 9.43119C8 10.2216 8.6282 10.8624 9.40312 10.8624Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLinkedin);
export default __webpack_public_path__ + "static/media/icon_linkedin.bd5326fd8d137a9e9912c4a0df0a0b97.svg";
export { ForwardRef as ReactComponent };